export const getMaxNumRecipes = () => 5
